// Campus photo for /colleges/rutgers-university-newark: CC BY 4.0, by ajay_suresh, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ARutgers_University%E2%80%93Newark_(55183771331).jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/rutgers-university-newark/; credited under the photo.
const photo = {
    "slug": "rutgers-university-newark",
    "alt": "Students walk under the red Rutgers Newark arch between two campus buildings on a sunny day",
    "src": "/colleges/rutgers-university-newark/campus-1600.webp",
    "srcSmall": "/colleges/rutgers-university-newark/campus-800.webp",
    "srcMid": "/colleges/rutgers-university-newark/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/rutgers-university-newark/og.jpg",
    "title": "Rutgers University-Newark (55183771331)",
    "author": "ajay_suresh",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ARutgers_University%E2%80%93Newark_(55183771331).jpg",
    "read": "2026-10-01"
};

export default photo;
